module.exports = __webpack_public_path__ + "img/19.bda52f32.png";